export default __webpack_public_path__ + "static/media/0342acb86da1af448d27a85d957a017a1577724086336.0b1e0256.webp";